//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/**
 * Defines the type of UI controls that can be rendered for filters
 * on the content collection pages.
 */
export const ContentCollectionFilterControl = {
    /**
     * Filter will be rendered as a pill and will behave as either a
     * radio button or checkbox.
     */
    Pills: 0,

    /** Filter will be rendered as a dropdown selection. */
    Dropdown: 1,

    /** Filter will be rendered as a single boolean option. */
    Boolean: 2
} as const;

/**
 * Defines the type of UI controls that can be rendered for filters
 * on the content collection pages.
 */
export const ContentCollectionFilterControlDescription: Record<number, string> = {
    0: "Pills",

    1: "Dropdown",

    2: "Boolean"
};

/**
 * Defines the type of UI controls that can be rendered for filters
 * on the content collection pages.
 */
export type ContentCollectionFilterControl = typeof ContentCollectionFilterControl[keyof typeof ContentCollectionFilterControl];
